module.exports = __webpack_public_path__ + "img/KristallinerstrandIstanbul.289ca3b7.jpg";